<div class="b-input__info-text">{{text}}<ng-content></ng-content></div>